import { Injectable } from '@angular/core';
import { _Service } from './_service';
import { AppId, CompanySite, Invite, Product } from '../../model';
import { AddressBookEntry } from '../../company/site_chain/address-book';

export type InviteRequest = { documents: AppId[]; product: { material: string; hsCode?: string; notes?: string } } & (
  | { invite: { email: string; name: string; phone: string; company: string } }
  | { invite: { companyId: string } }
  | {
      manual: {
        name: string;
        street: string;
        zip: string;
        city: string;
        country: string;
        state: string;
        siteType: string[];
        siteName: string;
      } & (object | { lat: number; lng: number });
    }
);

export type LinkCandidate = {
  id: string;
  name: string;
  hsCode?: string;
  articleNumbers: string[];
  siteId: string;
  siteName: string;
  companyId: string;
  companyName: string;
};

@Injectable({ providedIn: 'root' })
export class InviteService extends _Service<Invite> {
  constructor() {
    super('api/invite');
  }

  deleteInvite = async (data: { code: string }) => this.http.delete<Invite>(`api/invite/${data.code}`);
  loadInvite = async (inviteCode: string) => this.http.get<any>(`api/invite/${inviteCode}`);
  inviteSupplierForProduct = async (product: Product, data: InviteRequest) =>
    this.http.post<any>(`api/chain/${product.id}/invite`, data);
  acceptNewProduct = async (
    site: CompanySite,
    inviteCode: string,
    product: { name: string; hsCode?: string; notes?: string }
  ) => this.http.post<any>(`api/site/${site.id}/accept-invite`, { inviteCode, product });
  acceptExistingProduct = async (inviteCode: string, product: AppId) =>
    this.http.post<any>(`api/chain/${product}/accept-invite`, { inviteCode });
  listAll = async () => this.http.get<Invite[]>('api/invite');
  addInvite = async (inviteCode: string) => this.http.post<Invite>(`api/invite`, { inviteCode });
  linkCandidates = async (chainId: string) => this.http.get<LinkCandidate[]>(`api/chain/${chainId}/link-candidates`);
  addressBook = async () => this.http.get<AddressBookEntry[]>(`api/address-book`);
  linkExistingChain = async (chainId: string, data: { productId: string; documents: string[] }) =>
    this.http.post<{ id: string }>(`api/chain/${chainId}/link`, data);
}
